import type { IconSvgProps } from "@/types";

/** Small stroke icons for library UI. Decorative: hidden from screen readers. */
function Icon({
  size = 18,
  children,
  filled = false,
  ...props
}: IconSvgProps & { filled?: boolean }) {
  return (
    <svg
      aria-hidden="true"
      fill={filled ? "currentColor" : "none"}
      focusable="false"
      height={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      width={size}
      {...props}
    >
      {children}
    </svg>
  );
}

type IconProps = IconSvgProps & { filled?: boolean };

export const BookmarkIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M19 21l-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
  </Icon>
);

export const EyeIcon = (props: IconProps) => (
  <Icon {...props} filled={false}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle
      cx="12"
      cy="12"
      fill={props.filled ? "currentColor" : "none"}
      r="3"
    />
  </Icon>
);

export const CheckIcon = (props: IconProps) => (
  <Icon {...props} filled={false} strokeWidth={2.5}>
    <path d="M20 6L9 17l-5-5" />
  </Icon>
);

export const StarIcon = (props: IconProps) => (
  <Icon {...props}>
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z" />
  </Icon>
);

export const TrashIcon = (props: IconProps) => (
  <Icon {...props} filled={false}>
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
  </Icon>
);

export const EyeOffIcon = (props: IconProps) => (
  <Icon {...props} filled={false}>
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-6.5 0-10-7-10-7a18.5 18.5 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c6.5 0 10 7 10 7a18.5 18.5 0 0 1-2.16 3.19" />
    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
    <path d="M1 1l22 22" />
  </Icon>
);

export const FilmIcon = (props: IconProps) => (
  <Icon {...props} filled={false}>
    <rect height="20" rx="2.18" width="20" x="2" y="2" />
    <path d="M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5" />
  </Icon>
);

export const MoreIcon = (props: IconProps) => (
  <Icon {...props} filled={false} strokeWidth={3}>
    <path d="M5 12h.01M12 12h.01M19 12h.01" />
  </Icon>
);

export const SortIcon = (props: IconProps) => (
  <Icon {...props} filled={false}>
    <path d="M3 6h18M6 12h12M10 18h4" />
  </Icon>
);
